/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const imageCss = css({
  marginBottom: '25px',
  width: '100%',
  height: 'auto',
  [MediaQueries.mdAndUp]: {
    marginBottom: '10px',
  },
});

export const CaptionContainer = css(
  {
    fontWeight: fontWeights.regular,
  },
  typography.effra14,
);

export const CaptionGuide = css({
  marginRight: '8px',
  width: '20px',
  height: '2px',
  backgroundColor: colorsPalette.black,
  display: 'inline-block',
  marginBottom: '4px',
});

export const CaptionWrapperCss = css({ display: 'inline' });

export const containerMarginCss = {
  margin: '64px 0',
  [MediaQueries.md]: {
    margin: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    margin: '160px 0',
  },
};
